import React from 'react';
import Menu from '../Menu/Menu';
import './Training.css';
import t from '../../img/training2.png';

const Training = () => {
    return (
        <div className='mb-5'>
            <div className='about3'>
                <div className='bg'>
                    <Menu></Menu>
                    <h1 className='text-white display-5 fw-bold doris pt-lg-5 pb-5 mx-auto top'>Training & Course</h1>
                </div>
            </div>
            <div id="survey">
                <h2 className='heading pt-5 mx-3'>For Diploma Engineering Students</h2>
                <hr className='w-50 mx-auto'></hr>
                <h5 className='px-5 mx-lg-3'>
                    <div className='row'>
                        <div className='col-lg-6 col-md-6 col-sm-12 pt-3'>
                        Now days in world, education involves both a thorough academic
                        understanding and practical expertise in the field. Traditionally, education has
                        been based on on-campus instruction. Industrial training, on the other hand,
                        gives students hands-on experience by exposing them to or putting them in
                        confrontation with the real world. This helps them figure out if their skills and
                        the industry are a good match. This article examines students’ industrial
                        training experiences during 6-month period, with the purpose of establishing if
                        companies were successful in providing meaningful job experience.<br></br>
                        Industrial training is important, but so is training at a training institute, where
                        you can acquire and learn through practical instruction. We are committed
                        to you, teach you perfectly.<br></br>
                        Our selected fields for internship:<br></br>
                        <ol>
                            <li>
                                Civil Technology
                            </li>
                            <li>
                                Electrical Technology
                            </li>
                            <li>
                                Computer Technology
                            </li>
                        </ol>
                        </div>
                        <div className='col-lg-6 col-md-6 col-sm-12 pt-3'>
                            <img src={t} alt="" width="100%"/>
                        </div>
                    </div>
                </h5>
            </div>
        </div>
    );
};

export default Training;